enum CalendarAttendeeType {
  required
  optional
  resource
}

input CalendarEventAddressInput {
  city: String
  postcode: String
  region: String
  state: String
  street: String
}

input CalendarEventLocationInput {
  address: CalendarEventAddressInput
  name: String
}

input CalendarEventAttendeeInput {
  email: String
  name: String
  type: CalendarAttendeeType
}

input CalendarEventInput {
  attendees: [CalendarEventAttendeeInput!]
  body: String
  case_id: String!
  categories: [String!]
  end_time: String!
  is_online: Boolean
  locations: [CalendarEventLocationInput!]
  start_time: String!
  title: String!
  user_id: String
}

type CalendarEventCreationNoteResponse {
  note: Note
}
